<template>
  <div class="wrapper">
    <Tabs>
      <TabPane label="转化漏斗"></TabPane>
    </Tabs>
    <div class="t-charts-wrapper">
      <div id="tranferchart" :style="{width:chartsWidth+'px',height:chartHeight+'px'}"></div>
    </div>

  </div>
</template>

<script>
  let echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/funnel')
  require("echarts/lib/component/tooltip");
  require('echarts/theme/macarons');
  export default {
    name: "Transfer",
    props: {
      transferData: {
        type: Array,
        default: () => {
          return []
        }
      }

    },
    mounted() {
      this.setWH()
      this.$nextTick(() => {
        this.setE()
      })

    },
    watch: {
      transferData() {
        this.setE()
      }
    },

    data() {
      return {
        chartHeight: 0,
        chartsWidth: 0,
      }
    },
    methods: {
      setE() {
        let e = echarts.init(document.getElementById('tranferchart'),'macarons');
        let transferDataMap = {}
        let maxData=0
        this.transferData.forEach(ele => {
          transferDataMap[ele.name + ''] = ele
          if(ele.value>maxData){
            maxData=ele.value
          }
        })
        console.log(maxData)
        let option = {
          tooltip: {
            trigger: 'item',
            formatter:function (params) {
              return '转化率:'+(maxData==0?0:Number(params.value/maxData*100).toFixed(2)+'%')
            },
          },
          series: [
            {
              name: '漏斗图',
              type: 'funnel',
              minSize:2,
              label: {
                normal: {
                  show: true,
                  position: 'inside',
                  formatter:'{b}:{c}',
                  // color:'#000'
                  borderWidth: 2,
                  fontSize: 14

                },
                emphasis: {
                  textStyle: {
                    fontSize: 16
                  }
                }
              },
              data: this.transferData,
            }
          ]
        };
        e.clear()
        e.setOption(option)
      },

      setWH() {
        let w = document.getElementsByClassName('t-charts-wrapper')
        if (w.length > 0) {
          let h = w[0]
          this.chartHeight = Number(window.getComputedStyle(h).height.slice(0, -2))
          this.chartsWidth = Number(window.getComputedStyle(h).width.slice(0, -2))
        }
      },

    },

  }
</script>

<style scoped>
  .wrapper {
    width: 100%;
    height: 100%;
    /*background-color: lightpink;*/
  }

  .t-charts-wrapper {
    width: 100%;
    height: 350px;
  }

</style>
